export default "__VITE_PUBLIC_ASSET__a364f242__"